import {
  ABOUT_STATE,
  HOW_IT_WORKS_STATE,
  INITIAL_PAGE_STATE,
  REPORT_PAGE_STATE,
  LOGIN_STATE_NEW,
  MANAGE_STATE,
  LOGIN_STATE,
} from 'constants/constants';
import { Trigger } from 'types/trigger';
import { Views } from './types';

interface UseInitialPageViewParams {
  page: string;
  trigger: Trigger;
  isAngularLoaded: boolean;
  isConfigLoaded: boolean;
  isLogged: boolean;
}

export const getInitialPageView = ({
  page,
  trigger,
  isAngularLoaded,
  isConfigLoaded,
  isLogged,
}: UseInitialPageViewParams): Views | null => {
  // First check for skeleton page condition
  if (!isConfigLoaded || !isAngularLoaded || !trigger) {
    return Views.SkeletonPage;
  }

  switch (page) {
    case INITIAL_PAGE_STATE:
      return trigger === Trigger.Lst ? Views.InitialPageLst : Views.InitialPage;

    case REPORT_PAGE_STATE:
      return Views.ReportPage;

    case ABOUT_STATE:
      return Views.AboutPage;

    case HOW_IT_WORKS_STATE:
      return Views.HowItWorksPage;

    case LOGIN_STATE: {
      // if user is logged in, it loads the Manage page, else the old login page
      return isLogged ? Views.Manage : null;
    }

    case LOGIN_STATE_NEW:
      // if user is logged in, it loads the Manage page, else the new login page
      return isLogged ? Views.Manage : Views.Login;

    case MANAGE_STATE:
      return Views.Manage;

    default:
      return null;
  }
};
